module.exports = __webpack_public_path__ + "img/BS22.891034b0.svg";